import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { XmlResponseRequestDto } from 'ts-types/api.types';
import axios, { CancelTokenSource } from 'axios';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import { Button, Grid } from 'semantic-ui-react';
import FormContainer from 'components/layout/FormContainer';
import { MandateConsumerRenderProps, withMandateContext } from 'components/MandateContext';

interface Props extends MessageSourceProps, MandateConsumerRenderProps {
  tariffId?: number,
  mandateId?: number,
  xmlDetailsResponse?: XmlResponseRequestDto,
  onCancel: () => void,
}

interface State {
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class MediDataDownloadDetailsModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      cancelTokenSource: cancelTokenSource
    }

    props.getAllMandates();
  }

  render(): React.ReactNode {
    const {mandateId, tariffId, xmlDetailsResponse, currentMandates, onCancel, getMessage} = this.props;

    const currentMandate = currentMandates && currentMandates.find(mandate => mandate.id === mandateId);

    if (xmlDetailsResponse) {

      const totalErrors = xmlDetailsResponse.errors.length;

      return (
          <FormContainer>
            <PraxFormGrid>

              <Grid.Row>
                <Grid.Column width={6}>
                  <strong> {currentMandate ? currentMandate.name : ""} </strong>
                </Grid.Column>
                <Grid.Column width={6}>
                  <label>{getMessage("mediDataDownload.xmlResponse")}: </label>
                  <strong> {xmlDetailsResponse.status} </strong>
                </Grid.Column>
                <Grid.Column width={4}>
                </Grid.Column>
              </Grid.Row>

              <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

              <Grid.Row>
                <Grid.Column width={6}>
                  <label>{getMessage("mediDataDownload.billStatus")}: </label>
                  <strong>{xmlDetailsResponse.billStatus}</strong>
                </Grid.Column>
                <Grid.Column width={6}>
                  <strong>{xmlDetailsResponse.fileName}</strong>
                </Grid.Column>
                <Grid.Column width={4}>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  <label>{getMessage("mediDataDownload.patient")}: </label>
                  <strong>{xmlDetailsResponse.patientId}</strong>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <label>{getMessage("mediDataDownload.tariff")}: </label>
                  <strong>{tariffId}</strong>
                </Grid.Column>
              </Grid.Row>

              <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

              <Grid.Row>
                <Grid.Column width={8}>
                  <label>{getMessage("mediDataDownload.companyInfo")}: </label>
                </Grid.Column>
                <Grid.Column width={8}>
                  <label>{getMessage("mediDataDownload.contactInfo")}: </label>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <strong>{xmlDetailsResponse.companyContact.companyInfoHtml}</strong>
                </Grid.Column>
                <Grid.Column width={8}>
                  <strong>{xmlDetailsResponse.companyContact.contactInfoHtml}</strong>
                </Grid.Column>
              </Grid.Row>

              <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

              <Grid.Row>
                <Grid.Column>
                  <label>{getMessage("mediDataDownload.businessExplanation")}: </label>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <strong>{xmlDetailsResponse.reason}</strong>
                </Grid.Column>
              </Grid.Row>

              <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>
              { xmlDetailsResponse.errors.map((e, index) => (
                <>
                  <Grid.Row>
                    <Grid.Column>
                      <label>{getMessage("mediDataDownload.errorItem")}: </label>
                      <strong>{index + 1}/{totalErrors}</strong>
                    </Grid.Column>
                  </Grid.Row>

                  <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

                  <Grid.Row>
                    <Grid.Column>
                      <label>{getMessage("mediDataDownload.error")}: </label>
                      <strong>{e.code}</strong>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <strong>{e.text}</strong>
                    </Grid.Column>
                  </Grid.Row>

                  <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

                  <Grid.Row>
                    <Grid.Column>
                      <div>
                        Business: ->
                        {getMessage("mediDataDownload.errorValue")}: <strong>{e.errorValue}</strong>,
                        {getMessage("mediDataDownload.validValue")}: <strong>{e.validValue}</strong>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </>
                ))
              }

              <hr style={{width: '-webkit-fill-available', color: 'grey'}}/>

              <Button compact type="button" onClick={onCancel}>
                {getMessage("button.cancel")}
              </Button>
            </PraxFormGrid>
          </FormContainer>
      );
    }
  }

}

export default withMessages(withMandateContext(MediDataDownloadDetailsModal));
